'use client'

import React from 'react'
import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import type { FallbackProps } from 'react-error-boundary'
import { Button } from '../ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <Card className="my-4 border-red-200">
      <CardHeader>
        <CardTitle className="text-red-600">Something went wrong!</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mt-2">
          <pre className="text-sm overflow-auto p-2 bg-red-50 rounded">{error.message}</pre>
          <Button onClick={resetErrorBoundary} variant="outline" className="mt-4">
            Try again
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}

interface QueryErrorBoundaryProps {
  children: React.ReactNode
}

export const QueryErrorBoundary = ({ children }: QueryErrorBoundaryProps) => {
  const { reset } = useQueryErrorResetBoundary()

  return (
    <ReactErrorBoundary
      onReset={reset}
      FallbackComponent={ErrorFallback}
      onError={(error: Error) => {
        // Log error to your error reporting service
        console.error('Query Error:', error)
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default QueryErrorBoundary
